module.exports = __webpack_public_path__ + "img/serviceplanner-offers-de.13f1dd79.webp";